import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        status: "",
        user: {},
        token: "",
        statusFilter: "",
        followupStatusChange: "",
        menuData: {},
        leadFilterState: null,
        toast: {
            show: false,
            message: "",
            title: "",
            type: "success",
            timeout: 4000,
            key: 0,
        },
    },
    mutations: {
        auth_success(state, token) {
            state.status = "success";
            state.token = token;
        },
        logout(state) {
            state.status = "";
            state.token = "";
            state.user = false;
            state.leadFilterState = null;
        },
        setUpdateUser(state, data) {
            state.user = data;
        },
        setStatus(state, data) {
            state.statusFilter = data;
        },
        setFollowupStatusChange(state, data) {
            state.followupStatusChange = data;
        },
        setMenuData(state, data) {
            state.menuData = data;
        },
        setLeadFilterState(state, data) {
            state.leadFilterState = data;
        },
        clearLeadFilterState(state) {
            state.leadFilterState = null;
        },
        showToast(state, payload = {}) {
            state.toast = {
                show: true,
                message: payload.message || "",
                title: payload.title || "",
                type: payload.type || "success",
                timeout: payload.timeout !== undefined ? payload.timeout : 4000,
                key: state.toast.key + 1,
            };
        },
        hideToast(state) {
            state.toast.show = false;
        },
    },
    actions: {},
    getters: {
        isLoggedIn(state) {
            if (state.user) {
                return true;
            } else return false;
        },
        authStatus: (state) => state.status,
        getUser: (state) => {
            return state.user;
        },
        getStatus: (state) => {
            return state.statusFilter;
        },
        getFollowupStatusChange: (state) => {
            return state.followupStatusChange;
        },
        getMenuData: (state) => {
            return state.menuData;
        },
        getLeadFilterState: (state) => state.leadFilterState,
    },
});
